import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { useFetchPhotoGallery } from '../hooks/useAppInit';
import LineSeperator from '../components/ui/LineSeperator';
import eventImg from '../assets/SchoolEvent.jpg';
import audiImg from '../assets/SchoolEventAudi.jpg';
import otherImg from '../assets/SchoolEventOthr.jpg';
import buildingImg from '../assets/SchoolBuilding.jpg';
import '../stylings/GalleryAll.css';

const fallback = [
  { _id: 'g1', title: 'Annual Day 2024', coverImage: audiImg, count: 24, category: 'Events' },
  { _id: 'g2', title: 'Sports Day 2024', coverImage: eventImg, count: 18, category: 'Sports' },
  { _id: 'g3', title: 'Science Exhibition', coverImage: otherImg, count: 30, category: 'Academic' },
  { _id: 'g4', title: 'School Campus', coverImage: buildingImg, count: 15, category: 'Campus' },
  { _id: 'g5', title: 'Cultural Program', coverImage: audiImg, count: 22, category: 'Cultural' },
  { _id: 'g6', title: 'Republic Day 2024', coverImage: eventImg, count: 12, category: 'Events' },
  { _id: 'g7', title: 'Independence Day', coverImage: otherImg, count: 20, category: 'Events' },
  { _id: 'g8', title: 'Farewell Party', coverImage: audiImg, count: 35, category: 'Events' },
];

export default function GalleryAll() {
  useFetchPhotoGallery();
  const albums = useSelector((state) => state.photoGallery.albums);
  const displayAlbums = albums.length > 0 ? albums : fallback;
  const [search, setSearch] = useState('');

  const filtered = displayAlbums.filter((a) =>
    a.title.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Layout bannerTitle="Photo Gallery">
      <section className="inner-page-section">
        <div className="container-fluid px-5">
          <LineSeperator title="Photo Gallery" />
          <div className="gallery-search-bar mt-4">
            <input
              type="text"
              className="form-control"
              placeholder="Search albums..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <div className="row g-4 mt-2">
            {filtered.map((album) => (
              <div key={album._id} className="col-lg-3 col-md-4 col-sm-6">
                <Link to={`/gallery/${album._id}`} className="gallery-album-card">
                  <div className="gallery-album-thumb">
                    <img
                      src={album.coverImage || album.images?.[0] || buildingImg}
                      alt={album.title}
                    />
                    <div className="gallery-album-overlay">
                      <i className="fas fa-search-plus"></i>
                    </div>
                  </div>
                  <div className="gallery-album-info">
                    <h6>{album.title}</h6>
                    <span><i className="fas fa-images me-1"></i>{album.count || '–'} Photos</span>
                  </div>
                </Link>
              </div>
            ))}
          </div>
          {filtered.length === 0 && (
            <div className="text-center py-5 text-muted">No albums found.</div>
          )}
        </div>
      </section>
    </Layout>
  );
}
